export default __webpack_public_path__ + "static/media/logo1.a376ce8d.png";